module.exports = __webpack_public_path__ + "img/home-logo.8b8c013f.png";